import { jsx } from 'react/jsx-runtime';
import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const IconLlmInfoCircle = /*#__PURE__*/React.forwardRef((props, ref) => {
  return jsx("svg", Object.assign({
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon-llm-info-circle",
    width: "1em",
    height: "1em",
    "data-icon": "icon-llm-info-circle",
    "aria-hidden": "true"
  }, props, {
    ref: ref,
    children: jsx("path", {
      clipRule: "evenodd",
      d: "m12 2.4c-5.3 0-9.6 4.3-9.6 9.6s4.3 9.6 9.6 9.6 9.6-4.3 9.6-9.6-4.3-9.6-9.6-9.6zm-12 9.6c0-6.6 5.4-12 12-12s12 5.4 12 12-5.4 12-12 12-12-5.4-12-12zm11.7-3c.8 0 1.5-.7 1.5-1.5s-.7-1.5-1.5-1.5-1.5.7-1.5 1.5.7 1.5 1.5 1.5zm-.6 1.4c-.7 0-1.2.5-1.2 1.2 0 .6.4 1 .9 1.2v3.8c0 .6.2 1.1.6 1.5s.9.6 1.5.6c.7 0 1.2-.5 1.2-1.2 0-.6-.4-1-.9-1.2v-3.8c0-.6-.2-1.1-.6-1.5s-.9-.6-1.5-.6z",
      fill: "currentColor",
      fillRule: "evenodd"
    })
  }));
});
IconLlmInfoCircle.displayName = 'IconLlmInfoCircle';

export { IconLlmInfoCircle };
//# sourceMappingURL=llm-info-circle.js.map
